import { Table } from 'src/view/components/Table/Table';
import { SCREENS } from 'src/constants/screens';
import ScreenTabsNavigation, { IScreenTab } from 'src/view/containers/ScreenTabsNavigation/ScreenTabsNavigation';
import { USER_ROLES } from '~/constants/user';
import { hasRole } from '~/utils/helpers';

const getLogNavigationOptions = (): IScreenTab[] => {
  return [
    { path: SCREENS.WALLET_TRANSACTION_LOG(), title: 'wallet_log' },
    { path: SCREENS.BRANCHES_LOG(), title: 'branch_log' },
    { path: SCREENS.REFUND_LOG(), title: 'reports_refund_journal_tab_title' },
    { path: SCREENS.BRANCHES_WORKING_HOURS_LOG(':id'), title: 'wh_log_tab' },
  ];
};

const LogNavigation = () => {
  return (
    <div className="d-flex flex-column full-width">
      {!hasRole([USER_ROLES.FRANCHISEE, USER_ROLES.ACCOUNTING]) ? (
        <div className="d-flex flex-column flex-grow-1 pt-6">
          <Table>
            <ScreenTabsNavigation options={getLogNavigationOptions()} />
          </Table>
        </div>
      ) : null}
    </div>
  );
};

export default LogNavigation;
